<template>
  <div ref="focusTarget" class="container">
    <h2 class="question-title">{{ step.text }}</h2>
    <div class="text-question">
      <div class="text-question-content">
        <p class="drop">
          {{ step.box }}
          <draggable group="answer" :disabled="answer != null" :list="items1" class="value" :class="answerClass()" @change="handleDrop">
            <span ref="dropped"
              ><span v-if="this.answer != null">{{ step.responses[this.answer.value].text }}</span></span
            >
          </draggable>
        </p>
      </div>

      <draggable :removeCloneOnHide="false" class="text-question-list" :disabled="answer != null" :sort="false" :group="{ name: 'answer', pull: 'clone', put: false }" :list="items2" @change="log">
        <div v-for="item in items2" :key="item.value" class="drag text-question-list-item" :class="responseClass(item)">
          <span>
            {{ item.text }}
          </span>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

import StepFunctions from '@/src/components/mixins/StepFunctions.js'

export default {
  mixins: [StepFunctions],
  components: {
    draggable
  },
  mounted() {
    var answerIndex = this.answers.map(item => item.id).indexOf(this.stepKey)
    if (answerIndex > -1) {
      this.answer = this.answers[answerIndex]
    } else {
      this.answer = null
    }

    for (var i = 0; i < this.step.responses.length; i++) {
      this.items2.push({
        points: this.step.responses[i].points,
        text: this.step.responses[i].text,
        value: this.step.responses[i].value
      })
    }
  },
  data() {
    return {
      items1: [],
      items2: [],
      draggable: true,
      over: false
    }
  },
  methods: {
    log: function (evt) {
      window.console.log(evt)
    },
    fixActionRestriction() {
      document.body.classList.remove('smooth-dnd-no-user-select', 'smooth-dnd-disable-touch-action')
    },
    addActionRestriction() {
      document.body.classList.add('smooth-dnd-no-user-select', 'smooth-dnd-disable-touch-action')
    },
    // overwrite mixin
    getAnswerObject(newAnswer) {
      const answer = {
        id: this.stepKey,
        value: newAnswer.value,
        points: newAnswer.points
      }
      return answer
    },
    handleDrop(evt) {
      if (evt.hasOwnProperty('added')) {
        let data = evt.added.element
        this.answer = data
        this.$refs.dropped.innerHTML = data.text
      }

      /*this.over = false
      this.draggable = false
      */
    },
    onDrop(collection, dropResult) {
      this[collection] = this.applyDrag(this[collection], dropResult)
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
      window.focus()
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult

      if (removedIndex === null && addedIndex === null) return arr

      let data = payload
      this.over = false
      this.draggable = false
      this.answer = data
      this.$refs.dropped.innerHTML = data.text

      const result = [...arr]

      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },

    getChildPayload1(index) {
      return this.items1[index]
    },
    getChildPayload2(index) {
      return this.items2[index]
    },

    responseClass(option) {
      let className = ''
      if (!this.draggable) {
        className += 'no-checked '
      }
      if (this.answer === null) {
        return className
      }
      let answerPoints = option.points
      if (answerPoints > 0 && this.answer.value !== option.value) {
        className += 'correct'
      } else {
        if (this.answer.value === option.value) {
          className = 'hide'
        } else {
          className = 'no-checked'
        }
      }
      return className
    },
    answerClass() {
      if (this.answer === null) {
        return ''
      }
      let answerPoints = this.answer.points

      if (answerPoints > 0) {
        return 'correct'
      } else {
        return 'error'
      }
    }
  }
}
</script>

<style lang="scss">
input.answer {
  display: none;
  + label {
    padding-left: 0px;
    position: relative;
    border: 2px solid #fff;
    display: block;
    text-align: center;
    cursor: pointer;
    margin: 20px 35px;
    font-size: 19.6px;
    padding: 10px;
    &:hover {
      background: #f04e23;
      border-color: #f04e23;
    }
    @media (max-width: 768px) {
      padding: 10px;
      margin: 14px 10px;
    }
  }
  &:checked + label {
    background: #f04e23;
    border-color: #f04e23;
  }
}
.drag.correct {
  animation: correct-bg 3s forwards;
}
.drop .correct {
  animation: correct-bg 3s forwards;
}
.drag.hide {
  opacity: 0;
}
.drop .value {
  background-position: right 7px top -30px;
  transition: background-color 0.3s ease-in, background-position 0.3s ease-in;
}
.drop .correct {
  background-position: right 7px top 7px;
}
@media screen and (max-width: 767px) {
  .smooth-dnd-container.horizontal {
    display: block;
  }
  .smooth-dnd-container.horizontal > .smooth-dnd-draggable-wrapper {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/DragDrop.vue